// removed by extract-text-webpack-plugin
module.exports = {"poster-view":"poster-view","date-info":"date-info","title-section":"title-section","poster-title":"poster-title","info-section":"info-section","content-section":"content-section","content-type-picture":"content-type-picture","content-type-text":"content-type-text","poster-content":"poster-content","col-md-9":"col-md-9","col-md-12":"col-md-12","poster-footer":"poster-footer","footer-content":"footer-content","floating-register-btn":"floating-register-btn","register-now":"register-now"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/PosterView/PosterView.scss
// module id = 3+NE
// module chunks = 0